import { Divider, Typography } from 'antd'
import React from 'react'
import GSM_IntrasitDashboard from '../../../components/GSuperMarket/GSM_IntrasitDashboard/GSM_IntrasitDashboard'

const GSM_BinTransitPage = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Intransit Dashboard
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <GSM_IntrasitDashboard />
    </>
  )
}

export default GSM_BinTransitPage